<div class="app-input-array-container" fxLayout="row" fxLayoutGap="4px">

  <div fxFlex *ngFor="let value of inputs; let i = index; let isLast = last">

    <mat-form-field class="form-full-width" appearance="outline">
      <mat-label>{{label}} {{i + 1}}</mat-label>
      <input matInput [value]="value" (keyup)="onKeyUp($event, i)" (change)="changeArray(i, $event.target.value)"
        (focus)="currentFocus(i)" (blur)="loseFocus()">
      <button matSuffix mat-icon-button *ngIf="canDelete && i === index" (click)="removeInput(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-form-field>

    <button class="add-button" type="button" mat-raised-button color="accent"
      *ngIf="isLast && i !== index && i !== arrayValues.length - 1" [disabled]="arrayValues.includes('')"
      (click)="add()">
      <mat-icon>add</mat-icon>
    </button>

  </div>

  <div fxFlex class="disabled-section" *ngFor="let value of emptys">
  </div>

</div>

<div>
  <ng-content></ng-content>
</div>
